<template>
  <div-box>
    <nav-bar left-arrow :title="$t('身份输入')" bgColor="#000" />
    <div-padding padding="4vw 4vw 20vw">
      <p class="tit">{{ $t('身份信息') }}</p>
      <div-input>
        <div-card bg="#242424" padding='3vw' radius='2vw'>
          <van-field :border='false' clearable v-model='surname' :placeholder='$t("请输入姓名")'>
            <template #label>
              <div-width width='20vw'>
                <div-text size='4vw' color='#FFFFFF'>{{ $t('姓名') }}</div-text>
              </div-width>
            </template>
          </van-field>
        </div-card>
      </div-input>
      <div-height height='3vw' />
      <div-input>
        <div-card bg="#242424" padding='3vw' radius='2vw'>
          <van-field :border='false' clearable v-model='xing' :placeholder="$t('请输入姓拼音, 如`Zhang`')">
            <template #label>
              <div-width width=' 20vw'>
                <div-text size='4vw' color='#FFFFFF'>{{ $t('姓拼音') }}</div-text>
              </div-width>
            </template>
          </van-field>
        </div-card>
      </div-input>
      <div-height height='3vw' />
      <div-input>
        <div-card bg="#242424" padding='3vw' radius='2vw'>
          <van-field :border='false' clearable v-model='ming' :placeholder="$t('请输入名拼音, 如`San`')">
            <template #label>
              <div-width width='20vw'>
                <div-text size='4vw' color='#FFFFFF'>{{ $t('名拼音') }}</div-text>
              </div-width>
            </template>
          </van-field>
        </div-card>
      </div-input>
      <div-height height='3vw' />

      <p class="tit">{{ $t('证件信息') }}</p>
      <div-input>
        <div-card bg="#242424" padding='3vw' radius='2vw' @click="change(1)">
          <van-field :border='false' clearable v-model='nation' readonly is-link>
            <template #label>
              <div-width width='20vw'>
                <div-text size='4vw' color='#FFFFFF'>{{ $t('国籍') }}</div-text>
              </div-width>
            </template>
          </van-field>
        </div-card>
      </div-input>
      <div-height height='3vw' />
      <div-input>
        <div-card bg="#242424" padding='3vw' radius='2vw' @click="change(2)">
          <van-field :border='false' clearable v-model='document_type' readonly is-link>
            <template #label>
              <div-width width='20vw'>
                <div-text size='4vw' color='#FFFFFF'>{{ $t('证件类型') }}</div-text>
              </div-width>
            </template>
          </van-field>
        </div-card>
      </div-input>
      <div-height height='3vw' />
      <div-input>
        <div-card bg="#242424" padding='3vw' radius='2vw'>
          <van-field :border='false' clearable v-model='document_num' :placeholder='$t("请输入证件号")'>
            <template #label>
              <div-width width='20vw'>
                <div-text size='4vw' color='#FFFFFF'>{{ $t('证件号') }}</div-text>
              </div-width>
            </template>
          </van-field>
        </div-card>
      </div-input>
      <div-height height='3vw' />

      <p class="tit">{{ $t('银行卡信息') }}</p>
      <div-input>
        <div-card bg="#242424" padding='3vw' radius='2vw'>
          <van-field :border='false' clearable v-model='bank_name' :placeholder='$t("请输入银行名称")'>
            <template #label>
              <div-width width='20vw'>
                <div-text size='4vw' color='#FFFFFF'>{{ $t('银行名称') }}</div-text>
              </div-width>
            </template>
          </van-field>
        </div-card>
      </div-input>
      <div-height height='3vw' />

      <div-input>
        <div-card bg="#242424" padding='3vw' radius='2vw'>
          <van-field :border='false' clearable v-model='bank_num' :placeholder='$t("请输入银行卡号")'>
            <template #label>
              <div-width width='20vw'>
                <div-text size='4vw' color='#FFFFFF'>{{ $t('银行卡号') }}</div-text>
              </div-width>
            </template>
          </van-field>
        </div-card>
      </div-input>
      <div-height height='3vw' />

      <div-input>
        <div-card bg="#242424" padding='3vw' radius='2vw'>
          <van-field :border='false' clearable v-model='open_bank' :placeholder='$t("请输入开户行")'>
            <template #label>
              <div-width width='20vw'>
                <div-text size='4vw' color='#FFFFFF'>{{ $t('开户行') }}</div-text>
              </div-width>
            </template>
          </van-field>
        </div-card>
      </div-input>
      <div-height height='3vw' />
      <div-input>
        <div-card bg="#242424" padding='3vw' radius='2vw'>
          <p class="tt"> {{ $t('请上传银行卡照片（选填）') }}</p>
          <van-uploader v-model="fileList" max-count="1" preview-size="120" preview-image :after-read="afterRead" />
        </div-card>
      </div-input>
      <div-height height='10vw' />
      <div-btn @click.native="submit" radius="3vw" bg="linear-gradient(270deg, #FFD791 0%, #F4BB67 100%)">
        <div-text color='#242424' blod size='4vw'>{{ $t('确定') }}</div-text>
      </div-btn>
    </div-padding>
    <van-popup class="popupcode" style="width: 76%;top:40%;" closeable v-model="show">
      <div class="content">
        <van-radio-group v-model="radio" disabled v-if="type == 1">
          <van-radio name="1">{{ $t('中华人民共和国') }}</van-radio>
          <van-radio name="2">{{ $t('美国') }}</van-radio>
          <van-radio name="2">{{ $t('英国') }}</van-radio>
        </van-radio-group>
        <van-radio-group v-model="radio" disabled v-if="type == 2">
          <van-radio name="1">{{ $t('身份证') }}</van-radio>
          <van-radio name="2">{{ $t('户口本') }}</van-radio>
          <van-radio name="2">{{ $t('护照') }}</van-radio>
        </van-radio-group>
      </div>
    </van-popup>
  </div-box>
</template>

<script>
  export default {
    data() {
      return {
        surname: "",
        xing: '',
        ming: '',
        nation: '中华人民共和国',
        document_type: '身份证',
        document_num: '',

        bank_name: '',//银行名称
        bank_num: '',//银行卡号
        open_bank: '',//开户行
        fileList: [],

        loading: false,

        show: false,
        type: 1,//1国籍 2证件类型
        radio: '1',
      }
    },
    created() {
      if (this.urlQuery().type == 1) {
        this.getbank()
      }
    },
    methods: {

      getbank() {
        this.$get({
          url: "/api/v1/user/cards",
          loading: true,
          success: (res) => {
            this.surname = res.data.surname
            this.xing = res.data.xing
            this.ming = res.data.ming
            this.document_num = res.data.document_num
            this.bank_name = res.data.bank_name
            this.bank_num = res.data.bank_num
            this.open_bank = res.data.open_bank
            this.fileList = [
              {
                url: res.data.img_url
              }
            ]
          },
          tip: () => { },
        })
      }, change(index) {
        this.type = index
        this.show = true
      },
      afterRead(file) {
        file.status = "uploading";
        file.message = "上传中...";
        let data = new FormData()
        data.append('file', file.file)
        this.$post({
          url: "/api/v1/upload/local/image",
          upload: true,
          data,
          success: (res) => {
            file.status = 'done';
            file.url = res.data;
            file.status = "uploaded";
            file.message = "上传完成";
          },
          tip: () => {
            file.status = "failed";
            file.message = "上传失败";
          },
        })
      },
      submit() {
        let data = {}
        if (!this.surname) return this.$toast(this.$t("请输入姓名"))
        if (!this.xing) return this.$toast(this.$t("请输入姓拼音"))
        if (!this.ming) return this.$toast(this.$t("请输入名拼音"))
        if (!this.document_num) return this.$toast(this.$t("请输入证件号"))
        if (!this.bank_name) return this.$toast(this.$t("请输入银行名称"))
        if (!this.bank_num) return this.$toast(this.$t("请输入银行卡号"))
        if (!this.open_bank) return this.$toast(this.$t("请输入开户行"))

        let imageList = []
        this.fileList.forEach(item => { imageList.push(item.url) })

        data = {
          surname: this.surname,
          xing: this.xing,
          ming: this.ming,
          nation: this.nation,
          document_type: this.document_type,
          document_num: this.document_num,
          bank_name: this.bank_name,
          bank_num: this.bank_num,
          open_bank: this.open_bank,
          img: imageList,
        }
        this.loading = true
        this.$post({
          url: "/api/v1/user/cards/edit",
          data,
          success: (res) => {
            this.$toast({
              message: this.$t("操作成功"),
              onClose: () => {
                this.loading = false
                this.$router.push('tixian?type=2')
              }
            })
          },
          tip: () => {
            this.loading = false
          },
        })
      },

    },
  }
</script>
<style lang='less' scoped>
  .tit {
    width: 100%;
    color: #fff;
    font-size: 16px;
    font-weight: 550;
    padding: 5px 0 15px;
  }
  .tt {
    color: #fff;
    font-size: 14px;
    padding: 0 0 5px;
  }
  /deep/.van-field__control {
    color: #fff !important;
    font-size: 4vw !important;
  }
  .popupcode {
    .content {
      width: 100%;
      /deep/.van-radio-group {
        width: 90%;
        padding: 40px 10px 5px;
        .van-radio {
          margin-bottom: 10px;
        }
      }
    }
  }
</style>